import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ApiError } from '../../../lib/errors';
import { rpaRepository as repo } from '../../../lib/repositories/rpa.repository';
import type { DanhSachInstanceTongQuan, TongQuanRpa } from '../types';
import { KHOA_RPA, thuLai } from './useRpa';

/** Dashboard tự làm mới mỗi 30 giây như native; giữ số cũ trong lúc tải để biểu đồ không nháy về Skeleton. */
export const CHU_KY_TONG_QUAN_MS = 30_000;

export interface TruyVanTongQuan {
  days: number;
  projectId: string;
}

export function useSoLieuTongQuan(q: TruyVanTongQuan, bat = true) {
  return useQuery<TongQuanRpa, ApiError>({
    queryKey: KHOA_RPA.soLieuTongQuan(q),
    queryFn: () => repo.tongQuan(q),
    enabled: bat,
    staleTime: 15_000,
    refetchInterval: CHU_KY_TONG_QUAN_MS,
    placeholderData: keepPreviousData,
    retry: thuLai,
  });
}

export function useInstancesTongQuan(q: TruyVanTongQuan, bat = true) {
  return useQuery<DanhSachInstanceTongQuan, ApiError>({
    queryKey: KHOA_RPA.instancesTongQuan(q),
    queryFn: () => repo.instancesTongQuan(q),
    enabled: bat,
    staleTime: 15_000,
    refetchInterval: CHU_KY_TONG_QUAN_MS,
    placeholderData: keepPreviousData,
    retry: thuLai,
  });
}
